import { render } from "./CounterCarousel.vue?vue&type=template&id=404df972"
import script from "./CounterCarousel.vue?vue&type=script&lang=js"
export * from "./CounterCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/builds/lahautesociete/projects/roche/depistage-diabete/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__